// extracted by mini-css-extract-plugin
export default {"link":"WebUsers_link__vAJBn"};